import React from 'react'
import StockRegisterList from '../../components/stockregistercomponents/StockRegisterList';

function StockRegisterListPage() {
    return (
        <>

            {/*Dynamic content goes here */}
            <StockRegisterList />

        </>
    )
}

export default StockRegisterListPage;